import { Link } from 'react-router-dom';
import { hotRecommendations } from '@/mocks/homepage';

export default function HotRecommendSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          热门推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选全网最受欢迎的韩国漫画
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {hotRecommendations.map((item) => (
            <Link
              key={item.id}
              to="/category/all"
              className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative p-3 md:p-4">
                {item.isNew && (
                  <span className="absolute top-5 left-5 z-10 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-0.5 rounded-full whitespace-nowrap">
                    新
                  </span>
                )}
                <div className="w-full aspect-[3/4] overflow-hidden rounded-lg mb-3">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 韩漫在线热门推荐`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  />
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 text-center mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <div className="flex items-center justify-center gap-2 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{item.category}</span>
                  <span className="text-foreground-300">·</span>
                  <span className="flex items-center gap-0.5 whitespace-nowrap">
                    <i className="ri-star-fill text-primary-500 text-xs" />
                    {item.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}